<template>
    <div class="wrapper" :class="{ active: isOpen, static }">
        <slot name="header" :isOpen="isOpen">
            <CoreAccordionHeader
                :class="`${toggleMode}-mode`"
                :additionalClasses="headerClasses"
                @click.native="toggleContentVisibilityOnHeader"
            >
                <template #button>
                    <elm-arrows-chevron-up-regular-icon
                        size="24"
                        class="action-icon"
                        :class="isOpen ? 'up' : 'down'"
                        @click="toggleContentVisibilityOnIcon"
                    />
                </template>
                <template #title>
                    <slot name="title" />
                </template>
            </CoreAccordionHeader>
        </slot>

        <collapse-transition :duration="200">
            <CoreAccordionContent v-show="isOpen" :additionalClasses="contentClasses">
                <template v-if="$slots.body" #body>
                    <slot name="body" />
                </template>
            </CoreAccordionContent>
        </collapse-transition>
    </div>
</template>

<script lang="ts">
    import { Vue, Component, Emit, Prop } from 'vue-property-decorator';
    import { CollapseTransition } from 'vue2-transitions';
    import CoreAccordionHeader from '@/common/components/accordion/CoreAccordionHeader.vue';
    import CoreAccordionContent from '@/common/components/accordion/CoreAccordionContent.vue';
    import '@eloomi/icons/arrows/arrows-chevron-up-regular';

    @Component({
        components: {
            CoreAccordionHeader,
            CoreAccordionContent,
            CollapseTransition,
        },
    })
    export default class CoreAccordion extends Vue {
        @Prop({ default: true }) public showToggle!: boolean;
        @Prop() public value!: boolean;
        @Prop({ default: '' }) public headerClasses!: string;
        @Prop({ default: '' }) public contentClasses!: string;
        @Prop({ default: false }) public static!: boolean;
        @Prop({ default: 'icon' }) public toggleMode!: 'icon' | 'header';

        public get isOpen() {
            return this.value;
        }

        public toggleContentVisibilityOnIcon() {
            if (this.toggleMode === 'icon') {
                this.emitInput(this.static ? this.value : !this.value);
            }
        }

        public toggleContentVisibilityOnHeader() {
            if (this.toggleMode === 'header') {
                this.emitInput(this.static ? this.value : !this.value);
            }
        }

        @Emit('input')
        public emitInput(value: boolean) {
            return value;
        }
    }
</script>

<style lang="less" scoped>
    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: auto;

        &:not(.static) .header-mode {
            cursor: pointer;
        }

        .action-icon {
            display: flex;
            align-items: center;
            color: @info-color;
            transform: rotate(-180deg);
            cursor: pointer;
            transition: @generic-transition;

            &.up {
                transform: rotate(0);
            }
        }
    }
</style>
